import type { Dance, PlaybackSession } from "@recital-master/shared";

import { displayTitle } from "../lib/format";

type SessionMetadata = Pick<
  PlaybackSession,
  "deviceId" | "deviceLabel" | "nowPlaying"
>;

export function selectDisplacedPlayback({
  session,
  fallbackDance,
  dances,
  recitalArtwork,
  mediaUrl
}: {
  session: SessionMetadata | null;
  fallbackDance?: Dance | null;
  dances: Dance[];
  recitalArtwork: string | null;
  mediaUrl: (path: string | null) => string | null;
}) {
  const localDance =
    dances.find((dance) => dance.danceId === session?.nowPlaying?.danceId) ??
    fallbackDance ??
    null;
  const deviceLabel = session?.deviceLabel?.trim();

  return {
    artworkUri: localDance
      ? mediaUrl(localDance.thumbPath) ?? recitalArtwork
      : recitalArtwork,
    eyebrow: deviceLabel ? `Playing on your ${deviceLabel}` : "Playing on another device",
    fallbackSeed:
      localDance?.danceId ??
      session?.nowPlaying?.danceId ??
      session?.deviceId ??
      "displaced",
    title: localDance
      ? displayTitle(localDance.title)
      : session?.nowPlaying?.title ?? ""
  };
}
